//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Base64 } from 'js-base64'
import { sysUsers_insert, sysUsers_update, sysUsers_detail } from '@/apis/system'

export default {
    data() {
        //表單校驗
        const rules = {
            loginUsername: [{ required: true, message: '請輸入登錄用戶名！' }],
            realname: [{ required: true, message: '請輸入真實姓名！' }],
            sex: [{ required: true, message: '請選擇性別！' }],
            telphone: [{ required: true, message: '請輸入電話！' }],
            userNo: [{ required: true, message: '請輸入員工編號！' }],
            state: [{ required: true, message: '請選擇狀態！' }],
            isAdmin: [{ required: true, message: '請選擇是否為管理員！' }],
            resetPass: [{ required: true, message: '請選擇是否重置密碼！' }],
            confirmPwd: [{ validator: this.confirmPwdValidator }],
        };

        const form = {
            loginUsername: '',
            realname: '',
            sex: undefined,
            telphone: '',
            userNo: '',
            state: undefined,
            isAdmin: undefined,
            resetPass: '0',
            confirmPwd: undefined
        };

        return {
            id: '',
            form,
            rules,
            spinning: false,
            config: {
                //運動類型
                motions: [],
                gymnasiums: [],
            },
            labelCol: { style: { width: '150px', }, },
            wrapperCol: { span: 14, },
        }
    },
    async mounted() {
        this.id = this.$route.params.id;
        if (this.id > 0) {
            await this.onPageLoad();
        }
    },
    methods: {
        confirmPwdValidator(rule, value, callback) {
            if (this.form.resetPass == 1) {
                if (!value) {
                    return callback(new Error('請輸入新密碼！'));
                }
            }
            callback();
        },
        async onPageLoad() {
            try {
                const res = await sysUsers_detail(this.id);
                if (res.code == 0) {
                    const item = res.data || {};
                    const form = { ...this.form };
                    form.id = this.id;
                    form.loginUsername = item.loginUsername;
                    form.realname = item.realname;
                    form.sex = item.sex;
                    form.telphone = item.telphone;
                    form.userNo = item.userNo;
                    form.state = `${item.state}`;
                    form.isAdmin = `${item.isAdmin}`;
                    this.form = form;
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async handleFormValidate(e) {
            e.preventDefault();
            this.$refs.form.validate(async valid => {
                if (valid) {
                    await this.onSubmit();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        async onSubmit() {
            try {
                this.spinning = true;
                const submitForm = {
                    ...this.form,
                };
                if (this.id) {
                    //update
                    submitForm.recordId = this.id;
                    submitForm.resetPass = submitForm.resetPass == 1;
                    submitForm.defaultPass = false;
                    if (submitForm.resetPass) {
                        submitForm.confirmPwd = Base64.encode(submitForm.confirmPwd)
                    }


                    const res = await sysUsers_update(submitForm);
                    if (res.code == 0) {
                        this.$message.success('編輯完成');
                        this.$router.push('/security/account');
                    } else {
                        if (res.msg)
                            throw new Error(res.msg);
                    }
                } else {
                    //insert
                    const res = await sysUsers_insert(submitForm);
                    if (res.code == 0) {
                        this.$message.success('提交完成');
                        this.$router.push('/security/account');
                    } else {
                        if (res.msg)
                            throw new Error(res.msg);
                    }
                }
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.spinning = false;
            }
        }
    }
}
